import { cn } from '@core/utils';

import { Rating } from '@/app/donation/_components/Rating';

interface ReviewSummaryProps {
  reviewRating?: number;
  reviewCount: number;
  className?: string;
}

export const ReviewSummary = ({
  reviewRating,
  reviewCount,
  className,
}: ReviewSummaryProps) => {
  return (
    <div
      className={cn(
        'mb-8 flex flex-row items-center justify-center gap-20 rounded-small border border-Gray-200 bg-Gray-25 px-20 py-40',
        'mobile-tablet:mb-8 mobile-tablet:flex-col mobile-tablet:items-start mobile-tablet:gap-6 mobile-tablet:p-20',
        className,
      )}
    >
      <p
        className={cn(
          'font-500 text-Gray-600 typo-body1',
          'mobile-tablet:typo-body4',
        )}
      >
        답례품 만족도
      </p>
      <div className="h-32 w-1 border-l border-Gray-300 mobile-tablet:hidden" />
      <div className="flex items-center gap-4">
        <Rating
          value={reviewRating ?? 0}
          size={24}
          className="mr-16 mobile-tablet:mr-0"
        />
        <p
          className={cn(
            'font-700 text-Gray-900 typo-h3',
            'mobile-tablet:typo-h5',
          )}
        >
          {reviewRating}
        </p>
        <p
          className={cn(
            'font-500 text-Gray-500 typo-h5',
            'mobile-tablet:typo-body3',
          )}
        >
          /5.0
        </p>
        <p
          className={cn(
            'font-400 text-Gray-600 typo-body2',
            'mobile-tablet:typo-body4',
          )}
        >
          ({reviewCount}개)
        </p>
      </div>
    </div>
  );
};
